import isDev from "./devDetect";

export const definedWindow = (): boolean => {
  if (typeof window !== 'undefined') {
    return true;
  } else {
    return false;
  }
};

export const disableRightClick = (): boolean => {
  if (!isDev() && typeof window !== 'undefined') {
    document.onkeydown = function (e) {
      if (e.keyCode == 123) {
        return false;
      }
      if (e.ctrlKey && e.shiftKey && e.keyCode == 'I'.charCodeAt(0)) {
        return false;
      }
      if (e.ctrlKey && e.shiftKey && e.keyCode == 'C'.charCodeAt(0)) {
        return false;
      }
      if (e.ctrlKey && e.shiftKey && e.keyCode == 'J'.charCodeAt(0)) {
        return false;
      }
      if (e.ctrlKey && e.keyCode == 'U'.charCodeAt(0)) {
        return false;
      }
    };
    document.addEventListener('contextmenu', function (e) {
      e.preventDefault();
    });
  }
  return
}